import { render, staticRenderFns } from "./txt-dot.vue?vue&type=template&id=3b71bd42&"
import script from "./txt-dot.vue?vue&type=script&lang=js&"
export * from "./txt-dot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports